module.exports = __webpack_public_path__ + "img/btnBg.c95dc019.png";